import {Fragment} from "react";
import {Link} from "../../elements/link";
import {Text} from "../../elements/text";
import {useGetMediaBreakpoints} from "../../hooks/useMediaQuery.js";
import {theme} from "../../styles/theme.js";
import SectionWrapper from "../SectionWrapper";
import {BreadcrumpWrapper, Separator} from "./styles.js";

const BreadcrumbText = ({children, withHover = false, isTransparent}) => (
  <Text
    styles={{
      display: "inline",
      wordBreak: "break-word",
      ...(isTransparent ? {color: theme?.colors?.primaryWhite} : {}),
      ...(withHover
        ? {
            /*":hover": {fontWeight: "bold"}, transition: "all 0.15s ease"*/
          }
        : {fontWeight: "bold"}),
    }}
    type="textSmallRegular"
  >
    {children}
  </Text>
);

export default function Breadcrumbs({
  breadcrumb,
  isTransparent = false,
  isWhiteBg = false,
}) {
  const {breakpoints} = useGetMediaBreakpoints();
  const {isMobile} = breakpoints;
  const breadcrumbs = breadcrumb ? Object.keys(breadcrumb) : [];

  return (
    <SectionWrapper
      backgroundColor="grey"
      styles={{
        ...(isTransparent
          ? {
              position: "absolute",
              top: 90,
              left: 0,
              zIndex: 3,
              backgroundColor: "transparent",
            }
          : null),
        ...(isWhiteBg ? {backgroundColor: "white"} : null),
      }}
      innerWrapperStyles={{
        position: isTransparent ? "relative" : "initial !important",
        paddingInline: isMobile ? 10 : 65,
      }}
    >
      {!!breadcrumbs.length && (
        <BreadcrumpWrapper>
          {breadcrumbs?.map((t, i) => {
            const url = breadcrumb?.[t];

            return (
              <Fragment key={t}>
                {!url ? (
                  <BreadcrumbText isTransparent={isTransparent}>{t}</BreadcrumbText>
                ) : (
                  <Link outerStyles={{display: "inline"}} to={url}>
                    <BreadcrumbText isTransparent={isTransparent} withHover>
                      {t}
                    </BreadcrumbText>
                  </Link>
                )}
                {i !== breadcrumbs.length - 1 && (
                  <Separator isTransparent={isTransparent} />
                )}
              </Fragment>
            );
          })}
        </BreadcrumpWrapper>
      )}
    </SectionWrapper>
  );
}
